import React from "react"

import { Flex, Shimmer } from "components/common/index"

const ShipInfoLoading = () => (
  <Flex alignItems="center" flexDirection="column" minHeight="38px">
    <Shimmer height="22px" mb={1} width="50%" />
    <Shimmer height="16px" mb="4px" width="50%" />
    <Shimmer height="16px" width="60%" />
    {sl.config.enable_gift_preview_video && (
      <Shimmer height="16px" mt={3} width="50%" />
    )}
  </Flex>
)

export default ShipInfoLoading
